import React from 'react';
import { isNil } from 'lodash-es';
import { connect } from 'react-redux';
import { RelatedVideoList } from './related-video-list';
import { relatedVideosIqsRequestAction, relatedVideosRequestAction, relatedVideosResetAction } from './actions';
import { getIqsFeatureSelector } from 'common/selectors';

class RelatedVideos extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.videoId !== prevProps.videoId && !isNil(this.props.videoId)) {
      this.props.withIqs
        ? this.props.requestRelatedVideosIqs(this.props.videoId, '', [])
        : this.props.requestRelatedVideos(this.props.videoId, 1, []);
    }
  }

  componentWillUnmount() {
    this.props.resetRelatedVideos();
  }

  fetchNextPageRelatedVideos = () => {
    if (this.props.loading || this.props.total <= 0) {
      return;
    }

    if (this.props.withIqs) {
      if (this.props.pageCursor) {
        this.props.requestRelatedVideosIqs(this.props.videoId, this.props.pageCursor, this.props.videos);
      }
    } else {
      this.props.requestRelatedVideos(this.props.videoId, this.props.pageNumber + 1, this.props.videos);
    }
  };

  render() {
    return (
      <RelatedVideoList
        videos={this.props.videos}
        loading={this.props.loading}
        className={this.props.className}
        getNextVideos={this.fetchNextPageRelatedVideos}
        linkPrefix="/video/"
      />
    );
  }
}

const mapStateToProps = (state) => ({
  //FIXME @techdebt - I will move it to selectors
  loading: state.videoBox.loading || state.relatedVideos.loading,
  videoId: state.videoBox.video && state.videoBox.video.id,
  videos: state.relatedVideos.videos,
  total: state.relatedVideos.total,
  pageNumber: state.relatedVideos.pageNumber,
  pageCursor: state.relatedVideos.pageCursor,
  withIqs: getIqsFeatureSelector(state),
});

const dispatchStateToProps = (dispatch) => ({
  requestRelatedVideos: (videoId, pageNumber, videos) =>
    dispatch(relatedVideosRequestAction(videoId, pageNumber, videos)),
  requestRelatedVideosIqs: (videoId, pageCursor, pageSize, videos) =>
    dispatch(relatedVideosIqsRequestAction(videoId, pageCursor, pageSize, videos)),
  resetRelatedVideos: () => dispatch(relatedVideosResetAction()),
});

export const RelatedVideosDecorated = connect(mapStateToProps, dispatchStateToProps)(RelatedVideos);
